import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=e582d744&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=e582d744&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e582d744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\crmeb\\gitcode\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e582d744')) {
      api.createRecord('e582d744', component.options)
    } else {
      api.reload('e582d744', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=e582d744&scoped=true", function () {
      api.rerender('e582d744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/pageConfig/edit.vue"
export default component.exports